module.exports = __webpack_public_path__ + "static/media/fcm-push-notifications.c5617a55.png";